import { render, staticRenderFns } from "./voiceSearchBtn.vue?vue&type=template&id=09fb514b"
import script from "./voiceSearchBtn.vue?vue&type=script&lang=js"
export * from "./voiceSearchBtn.vue?vue&type=script&lang=js"
import style0 from "./voiceSearchBtn.vue?vue&type=style&index=0&id=09fb514b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports